import { FETCH_MTOKNA_OWNER_POINTS, CLEAN_MTOKNA_OWNER_POINTS, CREATE_MTOKNA_OWNER_POINT, DELETE_MTOKNA_OWNER_POINT } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const MTOKNA_OWNER_POINTS_DEFAULT_STATE = {};

const MtoknaOwnerPointsReducer = (state = MTOKNA_OWNER_POINTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_OWNER_POINTS:
            return payload;

        case CREATE_MTOKNA_OWNER_POINT:
            return { ...state, removes: [ ...state.removes, ...[payload.id] ] };

        case DELETE_MTOKNA_OWNER_POINT:
            return { ...state, removes: _.reduce(state.removes, (result, id) => {
                if (toNumber(payload.id) === toNumber(id)) {
                    return result;
                }

                return [ ...result, id ];
            }, []) };

        case CLEAN_MTOKNA_OWNER_POINTS:
            return MTOKNA_OWNER_POINTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaOwnerPointsReducer;
